import client from '../client'

export const getModelsKey = `${process.env.NEXT_PUBLIC_SEARCH_DOMAIN}/api/Models/GetModels`

export async function getModels({ makeId }) {
  const params = new URLSearchParams({ makeId })

  return client(`${getModelsKey}?${params.toString()}`)
}
